
























































































































import Vue from 'vue'
import Component from 'vue-class-component'
import axios, { AxiosError } from 'axios'

import { IModule } from '../../modules/types'
import { Prop, Watch } from 'vue-property-decorator'

import CreateDialog from './CreateDialog.vue'
import ModulesTile from './ModulesTile.vue'

import CreateExamModal, { ICreateExamData } from '../../exams/components/AddExamModal.vue'

import { ICourse } from '../types'
import { dispatchErrorMessage } from '../../core/utils'

@Component({
  components: {
    CreateDialog,
    CreateExamModal,
    ModulesTile
  }
})
export default class CourseForm extends Vue {
  @Prop({ default: () => ({}) })
  initialData!: ICourse

  @Prop({ default: () => [] })
  modules!: IModule[]

  @Prop({ default: false })
  adminView!: boolean

  paymentData = {} as any

  data: ICourse = {}

  dialog: boolean = false

  showCreateExamDialog = false

  get breadcrumbs() {
    return [
      { text: this.data.name, url: `/courses/${this.data.id}`}
    ]
  }

  get canManage(): boolean {
    return this.data && !!this.data.examId && this.modules.length > 0
  }

  get examExists(): boolean {
    return this.data && !!this.data.examId
  }

  get nonDraftModules(): IModule[] {
    return this.modules.filter(m => m.status !== 'draft')
  }

  get canTakeExam(): boolean {
    if (!this.examExists) {
      return false
    }

    return this.nonDraftModules.every((m: IModule) => m.quizStatus === 'completed')
  }
  
  get isEnrolled(): boolean {
    return 'examStatus' in this.data
  }

  get examVisible(): boolean {
    return this.examExists && this.isEnrolled && !this.courseCompleted && !this.courseFailed
  }

  get courseCompleted(): boolean {
    return this.data.examStatus === 'completed'
  }

  get courseFailed(): boolean {
    return this.data.examStatus === 'failed'
  }

  mounted() {
    this.data = { ...this.initialData }
  }

  submit(data: ICourse) {
    this.data.name = data.name
    this.data.certificationPrefix = data.certificationPrefix
    this.data.certificateName = data.certificateName
    this.data.summary = data.summary
    this.dialog = false
    this.$emit('submit', this.data)
  }

  openDialog() {
    this.dialog = true
  }

  @Watch('initialData')
  initialDataChanged(value: ICourse, oldValue: ICourse) {
    this.data = value
  }

  async directPass() {
    try {
      await axios.post(`/courses/${this.data.id}/direct-pass`)
      this.$emit('reload')
    } catch (error) {
      this.displayError(error)
    }
  }

  async publish() {
    try {
      await axios.post(`/courses/${this.data.id}/publish`)
      this.data.status = 'active'
      this.$store.dispatch('showSuccess', 'Course published successfully!')
    } catch (err) {
      this.displayError(err)
    }
  }

  async archive() {
    try {
      await axios.post(`/courses/${this.data.id}/archive`)
      this.data.status = 'disabled'
      this.$store.dispatch('showSuccess', 'Course archived successfully!')
    } catch (err) {
      this.displayError(err)
    }
  }

  async draft() {
    try {
      await axios.post(`/courses/${this.data.id}/draft`)
      this.data.status = 'draft'
      this.$store.dispatch('showSuccess', 'Course drafted successfully!')
    } catch (err) {
      this.displayError(err)
    }
  }

  displayError(error: AxiosError<{ message: string }>) {
    dispatchErrorMessage(error, this.$store.dispatch)
  }

  async createExam(data: ICreateExamData) {
    try {
      await axios.post(`courses/${this.data.id}/exams`, data)
      this.showCreateExamDialog = false
      this.$router.push(this.data.id + '/exam/edit')
    } catch (err) {
      this.displayError(err)
    }
  }

  async beginCourse() {
    try {
      await axios.post(`courses/${this.data.id}/enrol`)
      this.$store.dispatch('showSuccess', 'Successfully Enrolled!')
      this.$emit('reload')
    } catch (err) {
      this.displayError(err)
    }
  }

  confirmPaymentData(data: any) {
    this.paymentData = data
  }
}
